import { AnimaticState } from '@crossnokaye/ux-animatics';

import { AnimaticPrimitiveConfigStatus, LabelConfigVariant } from '@repo/sdk/models/components';

import {
  ANIMATIC_ESTOPPED,
  ANIMATIC_FAULTED,
  ANIMATIC_OFF,
  ANIMATIC_ON,
  ANIMATIC_PRIMARY_LABEL,
  ANIMATIC_SECONDARY_LABEL,
} from './constants';
import { AnimaticLabel, AnimaticLabelMap } from './types';

export const parseState = (state: AnimaticPrimitiveConfigStatus | undefined): AnimaticState => {
  switch (state) {
    case AnimaticPrimitiveConfigStatus.On:
      return ANIMATIC_ON;
    case AnimaticPrimitiveConfigStatus.Off:
      return ANIMATIC_OFF;
    case AnimaticPrimitiveConfigStatus.Faulted:
      return ANIMATIC_FAULTED;
    case AnimaticPrimitiveConfigStatus.Estopped:
      return ANIMATIC_ESTOPPED;
    default:
      return ANIMATIC_ON;
  }
};

export const bannerVariantTextClassName = (variant?: LabelConfigVariant): string => {
  switch (variant) {
    case LabelConfigVariant.EstoppedBanner:
      return 'text-ckds-text-fg-destructive';
    case LabelConfigVariant.FaultedBanner:
      return 'text-ckds-text-fg-default';
    default:
      return 'text-primary';
  }
};

export const bannerVariantBackgroundClassName = (variant?: LabelConfigVariant): string => {
  switch (variant) {
    case LabelConfigVariant.FaultedBanner:
      return 'bg-ckds-base-critical/90';
    case LabelConfigVariant.EstoppedBanner:
    default:
      return 'bg-secondary/90';
  }
};
/**
 * Gets a label from a map of labels by key
 * If the key is not found, it will return the first entry if the key starts with 'primary' and the second entry if the key starts with 'secondary'
 * If the key does not start with 'primary' or 'secondary', it will return the default label
 * @param labels - The map of labels
 * @param key - The key to get the label for
 * @returns The label
 */
export const getLabel = (labels: AnimaticLabelMap, key: string): AnimaticLabel => {
  const defaultLabel = {
    text: '',
    variant: LabelConfigVariant.Primary,
  };
  // Check if key exists in the map
  if (key in labels) {
    return labels[key];
  }

  // If key starts with 'primary', get first entry
  if (key.startsWith(ANIMATIC_PRIMARY_LABEL)) {
    const entries = Object.values(labels);
    return entries.length > 0 ? entries[0] : defaultLabel;
  }

  // If key starts with 'secondary', get second entry
  if (key.startsWith(ANIMATIC_SECONDARY_LABEL)) {
    const entries = Object.values(labels);
    return entries.length > 1 ? entries[1] : defaultLabel;
  }

  // Otherwise return undefined
  return defaultLabel;
};
